import type {CIFinding, DedupedCIFinding} from './ci-findings-types'

/**
 * Groups findings by `dedupKey` and returns one representative per group.
 * Findings without a dedupKey are treated as unique (never collapsed).
 * Preserves the order of first appearance.
 */
export function deduplicateCIFindings(findings: CIFinding[]): DedupedCIFinding[] {
  const groups = new Map<string, CIFinding[]>()
  const result: DedupedCIFinding[] = []

  for (const finding of findings) {
    const key = finding.dedupKey
    if (!key) {
      result.push({
        ...finding,
        dedupCount: 1,
        dedupedFindingIds: [finding.id],
      })
      continue
    }

    const existing = groups.get(key)
    if (existing) {
      existing.push(finding)
    } else {
      const group = [finding]
      groups.set(key, group)
      result.push({
        ...finding,
        dedupCount: 0,
        dedupedFindingIds: [],
      })
    }
  }

  // Finalize grouped entries with their totals.
  for (const deduped of result) {
    const key = deduped.dedupKey
    if (!key) continue

    const group = groups.get(key)
    if (!group) continue

    deduped.dedupCount = group.length
    deduped.dedupedFindingIds = group.map(f => f.id)
  }

  return result
}
